import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MainRoutingModule } from "./main-routing.module";
import { MainComponent } from "./main.component";
import { FullComponent } from "../layouts/full/full.component";
import { AppSidebarComponent } from "../layouts/full/sidebar/sidebar.component";
import { AppHeaderComponent } from "../layouts/full/header/header.component";
import { SharedModule } from "../shared/shared.module";
import { DriverPaymentComponent } from "./admin/admin-management/driver-payment/driver-payment.component";
import { environment } from "../../environments/environment";
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';

@NgModule({
  declarations: [
    MainComponent,
    FullComponent,
    AppSidebarComponent,
    AppHeaderComponent,
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule

    // DemoMaterialModule
  ],
})
export class MainModule {}
